import createVueComponent from '../createVueComponent';

const FlagTriangleLeft = createVueComponent('FlagTriangleLeftIcon', [
  ['path', { d: 'M17 22V2L7 7l10 5' }],
]);

export default FlagTriangleLeft;
